// Analytic Phonics — word families (rime + onsets that form real words).
// A learner sees the rime and swaps onsets to read the whole family aloud.
export const WORD_FAMILIES = [
  {
    rime: "AT",
    theme: "The -at family",
    onsets: ["C", "B", "H", "R", "M", "F", "S", "P"],
    example: "cat",
  },
  {
    rime: "IG",
    theme: "The -ig family",
    onsets: ["B", "D", "F", "P", "W"],
    example: "pig",
  },
  {
    rime: "OP",
    theme: "The -op family",
    onsets: ["H", "M", "P", "T", "C", "S"],
    example: "top",
  },
  {
    rime: "UG",
    theme: "The -ug family",
    onsets: ["B", "H", "J", "M", "R", "T", "P"],
    example: "bug",
  },
  {
    rime: "EN",
    theme: "The -en family",
    onsets: ["H", "P", "T", "M", "D", "B"],
    example: "hen",
  },
  {
    rime: "ILL",
    theme: "The -ill family",
    onsets: ["H", "P", "M", "F", "B", "W"],
    example: "hill",
  },
  {
    rime: "ING",
    theme: "The -ing family",
    onsets: ["K", "R", "W", "S", "P"],
    example: "king",
  },
  {
    rime: "IGHT",
    theme: "The -ight family",
    onsets: ["L", "N", "R", "S", "F", "T", "M"],
    example: "light",
  },
  {
    rime: "AKE",
    theme: "The -ake family",
    onsets: ["B", "C", "L", "M", "R", "T", "W"],
    example: "bake",
  },
  {
    rime: "AIN",
    theme: "The -ain family",
    onsets: ["R", "M", "P", "T", "G", "CH", "BR"],
    example: "rain",
  },
];
